function isServer() {
  return !process?.browser;
  // return typeof window === 'undefined';
}

module.exports = {
  isServer,
};
